import axios from "@/axios.js"

export default {
    fetch({ commit }, filters) {
        let queryString = ''
        if (filters) {
            queryString = '?' + Object.keys(filters).map(key => key + '=' + filters[key]).join('&');
        }
        commit('FETCH_CUSTOMERS')
        return new Promise((resolve, reject) => {
            axios.get("/api/customers/list" + queryString)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    save({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post('/api/customers/create', item)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    update({ commit }, item) {
        return new Promise((resolve, reject) => {
            axios.post('/api/customers/update/' + item.id, item)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
    delete({ commit }, id) {
        return new Promise((resolve, reject) => {
            axios.delete(`/api/customers/delete/${id}`)
                .then((response) => {
                    resolve(response)
                })
                .catch((error) => { reject(error) })
        })
    },
}